<template>
  <header>
    <nav class="top-nav" v-if="!home && isLogin">
      <div class="top-nav-in container flex">
        <router-link :to="{ path: '/' }" class="logo">
          <p class="textLogo" v-if="logo">{{logo}}</p>
          <img :src="logoImage" class="logo-img" v-else />
        </router-link>

        <!--        <form class="search" @submit.prevent="searchSubmit" v-if="$route.meta.useSearch">-->
        <!--          <el-input v-model="search" placeholder="请输入课程名或讲师名搜索"/>-->
        <!--        </form>-->
      </div>
    </nav>
    <nav class="top-nav" v-if="!home && !isLogin">
      <div class="top-nav-in container flex">
        <router-link :to="{ path: '/' }" class="logo">
          <!--          <p class="textLogo" v-if="logo">{{logo}}</p>-->
          <img :src="logoImage" class="logo-img" />
        </router-link>

        <form @submit.prevent="searchSubmit" class="search" v-if="$route.meta.useSearch">
          <el-input placeholder="请输入课程名或讲师名搜索" v-model="search" />
        </form>
      </div>
    </nav>

    <nav :style="{ backgroundColor: backColor }" class="main-nav-bar">
      <div class="container flex">
        <router-link :to="{ path: '/' }" class="logo" v-if="home">
          <!--          <p class="textLogo" v-if="logo">{{logo}}</p>-->
          <img :src="logoImage" class="logo-img" />
        </router-link>
        <el-menu class="main-nav" mode="horizontal" router>
          <template v-for="(it, index) in navList">
            <el-menu-item
              :class="it.isOn && 'nav-item-on'"
              :index="String(index)"
              :key="index"
              :route="{ path: it.path }"
              class="nav-item"
              v-if="it.subList == null && !(it.isShuziHidden && domain === 'szwy.eduqypeixun.com')"
            >{{it.name}}</el-menu-item>
            <el-submenu
              :class="it.isOn && 'nav-item-on'"
              :index="String(index)"
              :key="index"
              class="nav-item"
              popper-class="main-nav-popper"
              v-if="it.subList"
            >
              <template slot="title">{{it.name}}</template>
              <template v-for="(sub, i) in it.subList">
                <el-menu-item
                  :index="`${index}-${i}`"
                  :key="i"
                  :route="{ path: sub.path }"
                  class="sub-item"
                  v-if="!(sub.isShuziHidden && domain === 'szwy.eduqypeixun.com')"
                >
                  <!--                <i :class="sub.icon" />-->
                  <img :src="sub.icon" />
                  {{sub.name}}
                </el-menu-item>
              </template>
            </el-submenu>
          </template>
        </el-menu>

        <nav class="auth-nav">
          <template v-if="isLogin">
            <span class="nav-user-name">{{username}}</span>
            <a @click="logout" class="nav-logout">退出</a>
          </template>
          <template v-else>
            <router-link :to="{ path: '/login' }" class="nav-login">登录</router-link>
            <router-link :to="{ path: '/register' }" class="nav-register">&nbsp;|&nbsp; 注册</router-link>
          </template>
        </nav>
      </div>
    </nav>
  </header>
</template>

<script>
import mixins from '@/util/mixins'
import event from '@/util/event'
import { syncCeping } from '@/util/ceping'
import { debounce } from 'lodash'
import { userManageConds } from '@/store'
import '../assets/style/sign.css'

export default {
  name: 'topNav',

  mixins: [mixins],

  props: {
    home: {
      type: Boolean,
      default: false
    }
  },

  data () {
    const { keyword } = userManageConds()
    return {
      search: keyword,
      delaySearch: null
    }
  },

  computed: {
    backColor () {
      return this.$store.state.head_color || '#ef662f'
    },

    isLogin () {
      return !!this.$store.state.uname
    },
    college_id () {
      return this.$store.state.college_id
    },
    domain () {
      return this.$store.state.domain
    },

    username () {
      return this.$store.state.uname
    },

    logo () {
      return this.$store.state.title
    },

    logoImage () {
      return this.$store.state.logo
    },

    role () {
      return this.$store.state.role
    },

    isCeping () {
      return this.$store.state.isCeping
    },

    isUpPack () {
      return this.$store.state.is_up_pack
    },
    isSuperPack () {
      return this.$store.state.is_super_pack
    },
    cert_enable () {
      return this.$store.state.cert_enable === 1
    },

    // isShowExam() {
    //   return this.$store.state.isshow_exam
    // },

    navList () {
      const role = this.role
      const { nav } = this.$route.meta || {}
      if (role === 'user') {
        const subList = [
          { name: '我的课程', path: '/user/home' },
          { name: '我的作业', path: '/user/myhomework', isShuziHidden: true },
          { name: '我的问答', path: '/user/myask', isShuziHidden: true },
          // {name: '我的证书', path: '/user/certify'}
          // { name: '测评', path: '/user/ceping' }
        ]
        this.cert_enable && subList.push({ name: '我的证书', path: '/user/certify' })
        // this.isCeping &&
        // subList.push({ name: '测评推荐课程', path: '/user/recommendCourse' })
        return [
          { name: '首页', path: '/', isOn: nav == 'home' },
          { name: '课程', path: '/user/manage', isOn: nav == 'course' },
          { name: '直播', path: '/user/lives', isOn: nav == 'lives' },
          { name: '实战问答', path: '/user/ask', isOn: nav == 'ask', isShuziHidden: true },
          { name: '热点访谈', path: '/user/talk', isOn: nav == 'talk', isShuziHidden: true },
          { name: '职场充电', path: '/user/article', isOn: nav == 'article', isShuziHidden: true },
          { name: '个人中心', isOn: nav == 'my', subList }
        ]
      } else if (role === 'admin') {
        const subList = [
          { name: '课程管理', path: '/admin/manage', icon: require('../assets/img/course.png') },
          {
            name: '添加课程',
            path: '/admin/addCourse',
            icon: require('../assets/img/add.png'),
            isShuziHidden: true
          },
          {
            name: '课程分类管理',
            path: '/admin/courseClass',
            icon: require('../assets/img/fenlei.png'),
            isShuziHidden: true
          },
          {
            name: '课程讲师管理',
            path: '/admin/teacherManage',
            icon: require('../assets/img/jiangshi.png'),
            isShuziHidden: true
          }
        ]
        const staffSubList = [{
          name: '员工管理', path: '/admin/saff', icon: require('../assets/img/staffMange.png')
        }, {
          name: '添加必修课', path: '/admin/addRequiredCourse', icon: require('../assets/img/requriedCourse.png'), isShuziHidden: true
        }
        ]
        const navLists = [
          { name: '首页', path: '/', isOn: nav == 'home' },
          { name: '员工管理', path: `/admin/saff`, isOn: nav == 'saff', subList: staffSubList },
          { name: '课程管理', isOn: nav == 'course', subList },
          { name: '作业管理', path: `/admin/homework`, isOn: nav == 'homework', isShuziHidden: true }
          // { name: '考试管理', path: `/admin/adminExam`, isOn: nav == 'adminExam' },
          /*{ name: '订购管理', path: `/admin/setting`, isOn: nav == 'setting' },
          { name: '充值管理', path: `/admin/recharge`, isOn: nav == 'recharge' },*/
        ]
        // navLists.push({ name: '考试管理', path: `/admin/adminExam`, isOn: nav == 'adminExam' });
        navLists.push({ name: '考试管理', path: `/admin/adminExam`, isOn: nav == 'adminExam', isShuziHidden: true });
        (this.isUpPack || this.isSuperPack) && this.college_id !== 322 && this.college_id !== 454 && navLists.push({ name: '充值管理', path: `/admin/recharge`, isOn: nav == 'recharge', isShuziHidden: true });
        navLists.push({ name: '部门职位设置', path: `/admin/positionSetting`, isOn: nav == 'positionSetting' });

        return navLists;
      }
      return []
    }
  },

  created () {
    this.updateCeping()
    this.delaySearch = debounce(() => this.searchSubmit(), 588)
  },

  methods: {
    logout () {
      this.$axios.post('/api/studysys/common/getWebsiteAjax').then(({ data }) => {
        this.$store.commit('setValue', data.data)
        document.title = data.data.intro_title
      })
      // document.title = this.logo
      this.$store.commit('logout')
      this.$router.push({ name: 'Login' })
    },

    searchSubmit () {
      const keyword = (this.search || '').trim()
      event.$emit('headerSearchChange', { keyword })
    },

    async updateCeping () {
      if (this.isLogin && this.role == 'user') {
        const { isCeping } = await syncCeping()
        this.$store.commit('setValue', { isCeping })
      } else {
        this.$store.commit('setValue', { isCeping: false })
      }
    }
  },

  watch: {
    isLogin () {
      this.updateCeping()
    },

    $route: {
      handler: function (val, oldVal) {
        if (val.name !== 'manage') {
          this.search = ''
        }
      },
      deep: true
    },
    search () {
      const keyword = (this.search || '').trim()
      event.$emit('headerSearchChange', { keyword })
      this.delaySearch.cancel()
      this.delaySearch()
    }
  }
}
</script>


<style lang="scss">
.main-nav-popper {
  margin-top: -5px;

  .el-menu--popup {
    padding: 0;
    overflow: hidden;
    min-width: 100px;
    text-align: left;
  }

  .el-menu-item {
    color: #333 !important;

    &:hover {
      color: #fff !important;
      background-color: #374452 !important;
    }
  }
}
</style>


<style lang="scss" scoped>
@import '../assets/style/colors.scss';

.auth-nav {
  padding-right: 15px;
}

header {
  user-select: none;
}

.top-nav {
  display: flex;
  height: 80px;
  line-height: 80px;
}

.top-nav-in {
  align-items: center;
  justify-content: space-between;
}

.main-nav-bar {
  display: flex;
  width: 100%;
  height: 46px;
  line-height: 46px;
  background-color: $c-button;
  box-shadow: 0 2px 4px 0 rgba(199, 115, 31, 0.35);

  .logo {
    margin-right: 58px;
  }
}

.logo {
  display: flex;
  height: 100%;
  align-items: center;
}

.textLogo {
  font-size: 30px;
}

.logo-img {
  min-width: 90px;
  max-width: 580px;
  height: 50px;
}

.main-nav {
  flex: 1;
  border: 0;
  background-color: transparent;
}

.nav-item {
  position: relative;
  display: inline-block;
  height: 100%;
  line-height: 42px;
  border: solid transparent;
  border-width: 2px 0;
  box-sizing: border-box;
  overflow: hidden;
  color: #fff !important;
  font-size: 16px;
  padding: 0 12px;
  margin: 0 6px;

  &:hover,
  &:focus {
    color: #fff !important;
    background-color: transparent !important;
  }

  &:focus {
    color: #fff !important;
  }

  /deep/ .is-active:not(.nav-item-on) {
    border-bottom-color: transparent !important;
  }
}

.nav-item-on {
  font-size: 18px;
  border-bottom-color: #fff !important;

  /deep/ .el-submenu__title {
    font-size: 18px !important;
  }
}

.main-nav /deep/ .el-submenu {
  padding: 0;
}

.main-nav /deep/ .el-submenu__title {
  color: #fff !important;
  background-color: transparent !important;
  padding: 0 12px !important;
  font-size: 16px;
  line-height: 42px;
}

.main-nav /deep/ .el-icon-arrow-down {
  color: #fff;
  margin-top: -1px;
}

.nav-logout,
.nav-login,
.nav-register,
.nav-user-name {
  font-size: 16px;
  display: inline-block;
  color: #fff;
  user-select: none;
}

.nav-logout {
  margin-left: 0.5em;
  cursor: pointer;
}

.search {
  position: relative;

  .el-input {
    width: 360px;

    /deep/ input:focus {
      border-color: #e8e8e8;
    }
  }

  button {
    width: 88px;
    color: #fff;
    border-radius: 0;
    border-color: #f9af4e;
    background-color: #f9af4e;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/topNav.vue